import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-223">
      <div className="max-w-4xl mx-auto text-center" data-id="element-224">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00C853]/50 text-[#00C853] font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-6 tracking-wide" data-id="element-225">
          🏆 Sistema N°1 para Profes de Baby Fútbol en Argentina
        </div>

        <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-226">
          ⚽ PROFEPACK™
        </h2>
        <h3 className="text-xl sm:text-2xl font-bold text-[#00C853] mb-8" data-id="element-227">
          MEGAPACK BABYFÚTBOL LISTO
        </h3>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-8 max-w-xl" data-id="element-228">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-229">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['4-5', '6-7', '8-9', '10', '11-12', 'DT Kit'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #00C853'
            }} data-id="element-230">
                  <span className="text-white text-[10px] sm:text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-231">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00C853] text-black font-black text-[10px] sm:text-xs px-3 py-1 rounded-full whitespace-nowrap" data-id="element-232">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-6" data-id="element-233">
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-234">
            ✅ 4 a 12 años — Cancha de 5
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-235">
            ✅ 40 semanas + 80 sesiones por tomo
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-236">
            ✅ Correcciones técnicas y variantes incluidas
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-237">
            ✅ 100% contexto argentino de club de barrio
          </span>
        </div>
      </div>
    </section>;
}